import React, {useState } from 'react'
import { Button, Table } from 'reactstrap';

import { Trans } from "react-i18next";

const InvoiceValue = ({infos, value_key, issuing_company, year}) => {
    // {[r.value]}

    const ic = infos.filter(ii => ii.issuing_companies != null ? ii.issuing_companies.includes(issuing_company) : ii.issuing_company_id===issuing_company && ii.reference_year==year)[0]
    
    let val = null
    if(ic != null)
	val =  (typeof value_key === 'function' ? value_key(ic) : ic[value_key])

    return val != null ? <Trans values={{value: val}}>standard_formatting.currency</Trans> : '-'
}



export default ({infos, issuing_companies, type='INVOICES'}) => {
  let rows = null
  switch(type) {
	  case 'INVOICES':
	    rows = [{name: 'leftover', value_key: 'leftover'},
		          {name: 'leftover_exp', value_key: 'leftover_exp'},
		          {name: 'leftover_neg', value_key: 'leftover_neg'},
		          {name: 'leftover_net', value_key: ({leftover,leftover_exp}) => leftover-leftover_exp},
		          {name: 'leftover_total', value_key: ({leftover,leftover_neg}) => leftover+leftover_neg}]
	    break;
	  case 'ISSUING_COMPANIES':
	    rows = [{name: 'invoices_total_vat', value_key: 'invoices_total_vat', year: new Date().getFullYear()},
		          {name: 'invoices_365_vat', value_key: 'invoices_365_vat', year: new Date().getFullYear()},
		          {name: 'invoices_total_vat_1', value_key: 'invoices_total_vat', year: new Date().getFullYear()-1},
	    ]  
	    break;
  }
  return <div>
	  <Table striped className="std-table">
	    <thead>
		    <tr>
		      <td></td>
		      {issuing_companies.map(ic => <td key={ic.id}>{ic.name}</td>)}
		</tr>
	    </thead>
	    <tbody>
		    {rows.map(r => <tr  key={r.name}>
		      <React.Fragment>
			      <th><Trans>invoices_info.{r.name}</Trans></th>
			      {issuing_companies.map(ic => <td style={{width: '150px'}} key={ic.id}> <InvoiceValue infos={infos} value_key={r.value_key} year={r.year} issuing_company={ic.id} /></td>)}
		      </React.Fragment>
		    </tr>)}
	    </tbody>
	  </Table>
  </div>
}
